export default function WhiteSpec(){
  return (
    <div className="container h-[8px] bg-[#f4f4f6] md:hidden"></div>
  )
}
